import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class BlogTeaser extends Component {
  render() {
    return (
      <li className="col">
        <div className="blog_title">{this.props.name}</div>
        <a target="_blank" href={this.props.link}>{this.props.source} &raquo; </a>
        <div className="blog_teaser">
           {this.props.teaser}
        </div>
      </li>  
    );
  }
}

export default BlogTeaser;